/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CompanyPagedDto } from '../models/company-paged-dto';
import { ProductPagedDto } from '../models/product-paged-dto';

@Injectable({
  providedIn: 'root',
})
export class VendorService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation getVendors
   */
  static readonly GetVendorsPath = '/vendors';

  /**
   * Get vendors.
   *
   * Search vendors by company name or domain.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getVendors()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendors$Response(params?: {

    /**
     * Vendor&#x27;s name or domain
     */
    vendor?: string;

    /**
     * search not exact
     */
    fuzzy?: boolean;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<CompanyPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.GetVendorsPath, 'get');
    if (params) {
      rb.query('vendor', params.vendor, {});
      rb.query('fuzzy', params.fuzzy, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CompanyPagedDto>;
      })
    );
  }

  /**
   * Get vendors.
   *
   * Search vendors by company name or domain.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getVendors$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getVendors(params?: {

    /**
     * Vendor&#x27;s name or domain
     */
    vendor?: string;

    /**
     * search not exact
     */
    fuzzy?: boolean;
    page?: number;
    size?: number;
  }): Observable<CompanyPagedDto> {

    return this.getVendors$Response(params).pipe(
      map((r: StrictHttpResponse<CompanyPagedDto>) => r.body as CompanyPagedDto)
    );
  }

  /**
   * Path part for operation getProducts
   */
  static readonly GetProductsPath = '/vendors/{vendorDomain}/products';

  /**
   * Get vendor products.
   *
   * Use this to find all products associated with a single vendor.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getProducts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts$Response(params: {
    vendorDomain: string;
    productName?: string;
    page?: number;
    size?: number;
  }): Observable<StrictHttpResponse<ProductPagedDto>> {

    const rb = new RequestBuilder(this.rootUrl, VendorService.GetProductsPath, 'get');
    if (params) {
      rb.path('vendorDomain', params.vendorDomain, {});
      rb.query('productName', params.productName, {});
      rb.query('page', params.page, {});
      rb.query('size', params.size, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductPagedDto>;
      })
    );
  }

  /**
   * Get vendor products.
   *
   * Use this to find all products associated with a single vendor.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getProducts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getProducts(params: {
    vendorDomain: string;
    productName?: string;
    page?: number;
    size?: number;
  }): Observable<ProductPagedDto> {

    return this.getProducts$Response(params).pipe(
      map((r: StrictHttpResponse<ProductPagedDto>) => r.body as ProductPagedDto)
    );
  }

}
